import { meta } from '@/helpers/constants/router';
const Wrapper = () => import('@/views/Wrapper.vue');
const LaunchThankYou = () => import('@/views/v2/diy/LaunchThankYou.vue');
export default [
    {
        path: 'mini-app-launched-success',
        component: Wrapper,
        children: [
            {
                path: '/',
                name: 'mini-app-launched-success',
                component: LaunchThankYou,
                meta: { ...meta, title: 'In-App Store Launched Success' },
            },
        ],
    },
];
